var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.keyword.keywordContents.filter((content) => {
        return content.language == 'de-CH';
      })[0]
    )?_c('span',[_vm._v("\n    "+_vm._s(_vm.keyword.keywordContents.filter((content) => {
        return content.language == "de-CH";
      })[0].value)+"\n  ")]):_c('span',[_vm._v(" - ")]),_vm._v(" /\n  "),(
      _vm.keyword.keywordContents.filter((content) => {
        return content.language == 'fr-CH';
      })[0]
    )?_c('span',[_vm._v("\n    "+_vm._s(_vm.keyword.keywordContents.filter((content) => {
        return content.language == "fr-CH";
      })[0].value)+"\n  ")]):_c('span',[_vm._v(" - ")]),_vm._v(" /\n  "),(
      _vm.keyword.keywordContents.filter((content) => {
        return content.language == 'it-CH';
      })[0]
    )?_c('span',[_vm._v("\n    "+_vm._s(_vm.keyword.keywordContents.filter((content) => {
        return content.language == "it-CH";
      })[0].value)+"\n  ")]):_c('span',[_vm._v(" - ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }